module.exports = __webpack_public_path__ + "static/morgan-65e675d919885ea09210d14f6917c308.jpg";